<template>
  <div class="ab-report__content">
    <div v-if="isLoading">
      <ui-loading-circle />
    </div>
    <div v-else>
      <section class="device__select">
        <div class="heatmap__control-bar-top">
          <div
            :class="{ 'mobile-only': bMobile }"
            class="heatmap__control__device"
          >
            <button
              v-for="item in deviceList"
              :key="item"
              :class="{ on: device === item }"
              class="item"
              @click="onDeviceChange(item)"
            >
              <i :class="`icon--device-${item}`" class="icon"></i>
              <template v-if="bMobile">
                <span class="text device_name">{{
                    $t('common.deviceType.phone')
                  }}</span>
                <span class="delimiter"></span>
              </template>
              <span v-if="entirePv" class="text percentage"
              >{{ getDevicePvPercentage(item) | fixed(1) }}%</span
              >
              <span v-else class="text percentage">0%</span>
            </button>
          </div>
          <div class="heatmap__control__play">
            <span
              v-for="item in eventSourceButtons"
              :key="item.key"
              :class="getEventSourceClass(item.key)"
              class="checkbox_wrap"
              @click="setEventSource(item.key)"
            >
              <i class="icon icon--chkbox"></i>
              <span class="text">{{ $t(item.t) }}</span>
            </span>
          </div>
          <div class="heatmap__control_guide">
            <span>{{ $t('common.guide.title') }}</span>
            <a :href="goLink" target="_blank">{{ $t('common.guide.more') }}</a>
            <i class="icon icon--bc-step"></i>
          </div>
        </div>
      </section>
      <!-- a/b capture image -->
      <section class="content__capture">
        <ABreportResultPath v-if="!isResultLoading && reportData[0] !=='check' && reportData.length >0"
                            :pathBottom="pathBpostion"
                            :pathHeight="pathHeight"
                            :pathTop="pathApostion"
                            :pathValue="pathValue" :pathWidth="pathWidth" :resultType="reportData[0]" />
        <div
          v-for="abType in abTypes"
          :key="abType"
          :ref="`${abType}HalfWidthBox`"
          :class="`${abType}-page`"
          class="box-layout"
        >
          <div
            :class="{
              aType: abType === 'a' && abData[abType].url.length > 148
            }"
            class="capture__info"
          >
            <div class="label">
              <span>{{ abType | upperFirst }}</span>
            </div>
            <div class="info">
              <p class="infos">
                <span :title="abData[abType].pageName" class="name">{{
                    abData[abType].pageName
                  }}</span>
                <span class="traffic">{{ abHalfTraffic }}%</span>
              </p>
              <p v-if="abTestType === 'url' || abType === 'a'" class="url">
                <a :href="abData[abType].url" target="_blank"
                ><i class="icon icon--link-size16"></i
                ></a>
                {{ abData[abType].url }}
              </p>
              <p v-else class="items">
                {{ $t('ab.edit') }}:
                <span style="color: #1199af">{{ bData.textCount }}</span>
              </p>
            </div>
          </div>
          <figure ref="figure" class="capture__img">
            <img
              v-if="imageData[abType] && imageData[abType].url"
              :id="`${abType}PageCapture`"
              :alt="`${abType} page capture image`"
              :src="imageData[abType].url"
              :style="{maxWidth: imageData[abType] ? `${imageData[abType].width}px`: '0px'}"
            />
          </figure>
        </div>
      </section>

      <!-- a/b text result -->
      <section v-if="!isAiDisabled" :class="`content__result ${resultTypeClass}`">
        <div ref="resultBox" class="box-layout">
          <div class="sub-title">
            <h6>{{
                $t('ab.report.default.testResult.title')
              }}</h6>
            <div v-if="!isResultLoading" class="title-right">
              <span>Powered by UX GPT</span>
              <i class="icon icon--ai-tag"></i>
              <span class="result-bot"></span>
            </div>
          </div>
          <div v-if="isResultLoading" class="result-loading">
            <i class="icon loading-bot"></i>
            <span class="loading-msg">{{
                $t('ab.report.default.testResult.loading')
              }}</span>
          </div>

          <!--          선택 : A, 선택 : B, 근거 :-->
          <div v-else class="result-data">
            <p v-if="reportData[1]" class="result-answer selected">
              <span
                class="tit">{{ reportData[0] === 'check' ? $t('ab.report.default.testResult.furtherConfirm') : $t('ab.report.default.testResult.resultType', { type: reportData[0].toUpperCase() })
                }}</span>
              <span class="desc" v-html="reportData[1]"
              ></span
              >
            </p>
            <p v-if="reportData[2]" class="result-answer action">
              <span class="tit">Next action:</span>
              <span class="desc" v-html="reportData[2]"
              ></span
              >
            </p>
          </div>
        </div>
      </section>

      <!-- traffic ratio -->
      <section class="content__traffic-ratio">
        <div class="box-layout">
          <div>
            <span class="sub-title">{{
                $t('ab.report.default.trafficRatio.label')
              }}</span>
            <span class="traffic-ratio__formula">
              {{ trafficSummary }}
            </span>
          </div>
          <div ref="trafficRatioWrapper" class="traffic-ratio__bar">
            <div
              v-for="abType in abTypes"
              :key="abType"
              :class="[
                `${abType}-page__area`,
                { noBarWidth: trafficBarWidth < 1.6 }
              ]"
              :style="{ width: trafficBarWidth + '%' }"
            >
              <span :class="`value__${abType}-page`">{{ abHalfTraffic }}%</span>
            </div>
            <span v-if="abTraffic !== 100" class="value__exclude"
            >{{ 100 - abTraffic }}%</span
            >
          </div>
        </div>
      </section>

      <!-- ab target -->
      <section
        v-if="targetData.length > 0"
        class="content__conversion-target-rate"
      >
        <div class="title__wrap">
          <p class="title">{{ $t('ab.report.default.ctr.title') }}</p>
          <ul class="button__wrap">
            <li :class="{ on: isFlowList }" @click="onChangeView('flow')">
              <i class="icon icon--abtest-flow"></i>
              <span>Flow</span>
            </li>
            <li :class="{ on: !isFlowList }" @click="onChangeView('list')">
              <i class="icon icon--list"></i>
              <span>List</span>
            </li>
          </ul>
        </div>
        <div v-if="isFlowList" class="box-layout flow">
          <div class="box-layout-inner__wrap">
            <div
              :style="{ marginTop: divisionHeight / 2 - 65 + 'px' }"
              class="page-division__wrap"
            >
              <div class="label__wrap">
                <p class="a">{{ analyticsData.a.pvTotal }} PV</p>
                <div class="a-label">
                  <i>A</i>
                </div>
                <div class="drop-off">
                  <i
                    v-if="targetDropOff.AState == 'large'"
                    class="icon icon--arrow-dropoff-large"
                  ></i>
                  <i
                    v-if="targetDropOff.AState == 'medium'"
                    class="icon icon--arrow-dropoff-medium"
                  ></i>
                  <i
                    v-if="targetDropOff.AState == 'small'"
                    class="icon icon--arrow-dropoff-small"
                  ></i>
                  <span>{{ targetDropOff.a | fixed(1) }}%</span>
                </div>
              </div>
              <div class="label__wrap">
                <p class="b">{{ analyticsData.b.pvTotal }} PV</p>
                <div class="b-label">
                  <i>B</i>
                </div>
                <div class="drop-off">
                  <i
                    v-if="targetDropOff.BState == 'large'"
                    class="icon icon--arrow-dropoff-large"
                  ></i>
                  <i
                    v-if="targetDropOff.BState == 'medium'"
                    class="icon icon--arrow-dropoff-medium"
                  ></i>
                  <i
                    v-if="targetDropOff.BState == 'small'"
                    class="icon icon--arrow-dropoff-small"
                  ></i>
                  <span>{{ targetDropOff.b | fixed(1) }}%</span>
                </div>
              </div>
            </div>
            <div
              v-show="groupHeight"
              id="node__wrap"
              ref="nodewrap"
              class="node__wrap"
            >
              <svg class="trend-paths">
                <defs>
                  <linearGradient
                    id="Gradienta"
                    gradientTransform="rotate(360)"
                  >
                    <stop offset="0%" stop-color="white" />
                    <stop offset="5%" stop-color="#1199af" />
                  </linearGradient>
                </defs>
                <defs>
                  <linearGradient
                    id="Gradientb"
                    gradientTransform="rotate(360)"
                  >
                    <stop offset="0%" stop-color="white" />
                    <stop offset="5%" stop-color="#9fce12" />
                  </linearGradient>
                </defs>
                <template
                  v-for="(sequence, sequenceIndex) in conversionTargetData"
                >
                  <template
                    v-for="(conversion, conversionIndex) in sequence.conversion"
                  >
                    <g :key="'nodepath' + sequenceIndex + conversionIndex">
                      <node-path
                        :AHeight="AHeight"
                        :APrev="APrev"
                        :BHeight="BHeight"
                        :BPrev="BPrev"
                        :conversion="conversion"
                        :divisionHeight="divisionHeight"
                        :groupHeight="groupHeight"
                        :length="conversionTargetData.length"
                        :sequenceIndex="sequenceIndex"
                        :stroke="`url('#Gradient${
                          conversion.bAB === true ? 'a' : 'b'
                        }')`"
                        :strokeWidth="
                          conversionRate(
                            conversion.bAB !== true ? sequence.a : sequence.b
                          )
                        "
                      ></node-path>
                    </g>
                  </template>
                </template>
              </svg>
            </div>
            <div ref="targetwrap" class="target__wrap">
              <template v-for="(item, idx) in targetData">
                <div
                  v-if="item.aid"
                  :key="item.aid"
                  ref="targetList"
                  class="target"
                >
                  <div class="ratio__wrap">
                    <div class="a ratio">{{ item.a | fixed(1) }}%</div>
                    <div class="b ratio">{{ item.b | fixed(1) }}%</div>
                  </div>
                  <div class="thumbnail">
                    <img
                      v-if="item.imgSrc && item.imgSrc.indexOf('http') > -1"
                      :src="item.imgSrc"
                    />
                    <i
                      v-else
                      :class="{ deleted: item.deleted }"
                      class="icon icon-empty-image"
                    />
                  </div>
                  <div
                    :class="{ deleted: item.uiState === 'deleted' }"
                    class="info"
                  >
                    <div class="status__wrap">
                      <span class="matchtype">{{
                          item.matchType | matchType(true)
                        }}</span>
                      <i
                        v-if="item.uiState === 'deleted'"
                        class="icon icon--deleted"
                        @mouseenter="item.showTargetTooltip = true"
                        @mouseleave="item.showTargetTooltip = false"
                      >
                        <ui-tooltip
                          v-if="item.showTargetTooltip"
                          arrowCenter
                          noApplyCenterAnimate
                        >
                          <span v-html="$t('ab.report.default.cvr.tooltip')" />
                        </ui-tooltip>
                      </i>

                      <span v-if="item.uiState === 'end'" class="status end">{{
                          $t('ab.report.default.cvr.endByPvLimit')
                        }}</span>
                      <span
                        v-if="item.uiState === 'scheduled'"
                        class="status scheduled"
                      >{{ $t('ab.report.default.cvr.scheduledRun') }}</span
                      >
                      <span
                        v-if="item.uiState === 'deleted'"
                        class="status delete"
                      >{{ $t('ab.report.default.cvr.deleted') }}</span
                      >
                      <span
                        v-if="item.uiState === 'analyzing'"
                        class="status analyzing"
                      >{{ $t('ab.report.default.cvr.analyzing') }}</span
                      >
                      <span
                        v-if="item.uiState === 'stop'"
                        class="status stop"
                      >{{ $t('ab.report.default.cvr.stop') }}</span
                      >
                      <span
                        v-if="item.uiState === 'tempstop'"
                        class="status tempstop"
                      >{{ $t('ab.report.default.cvr.stop') }}</span
                      >
                    </div>
                    <div class="info-title__wrap">
                      <i
                        v-if="item.uiState !== 'deleted'"
                        :class="{ disabled: item.uiState === 'scheduled' }"
                        class="icon icon--common-page-link clipboard"
                        @click="onViewApplyClick(item)"
                      ></i>
                      <i
                        v-if="item.bAB"
                        class="icon icon--ab-test-exist ab"
                      ></i>
                      <span class="title">{{ item.pageName }}</span>
                    </div>
                    <div class="url__wrap">
                      <a
                        :href="item | applyUrl"
                        class="link_to_site"
                        target="_blank"
                      >
                        <i
                          v-if="item.uiState !== 'deleted'"
                          class="icon icon--common-page-link-blue clipboard"
                        ></i>
                      </a>
                      <div v-if="item.showToastLayer" class="content__toast">
                        <span>{{ $t('common.trackingCode.copied') }}</span>
                        <i class="icon icon--check-green-size16"></i>
                      </div>
                      <div class="textarea">
                        <span @click="copyCode($event, idx)">
                          {{ item.url }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div ref="etc" class="target etc">
                <div class="ratio__wrap ratio-etc">
                  <div class="a ratio">{{ targetEtc.a | fixed(1) }}%</div>
                  <div class="b ratio">{{ targetEtc.b | fixed(1) }}%</div>
                </div>
                <div class="etc">etc.</div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="box-layout">
          <template v-for="(item, index) in targetData">
            <div
              :key="index"
              :class="{ first: index === 0 }"
              class="box-layout-table__wrap"
            >
              <div
                :class="{ deleted: item.uiState === 'deleted' }"
                class="info"
              >
                <div class="status__wrap">
                  <span class="matchtype">{{
                      item.matchType | matchType(true)
                    }}</span>
                  <i
                    v-if="item.uiState === 'deleted'"
                    class="icon icon--deleted"
                    @mouseenter="item.showTargetTooltip = true"
                    @mouseleave="item.showTargetTooltip = false"
                  >
                    <ui-tooltip
                      v-if="item.showTargetTooltip"
                      arrowLeft
                      noApplyCenterAnimate
                    >
                      <span v-html="$t('ab.report.default.cvr.tooltip')" />
                    </ui-tooltip>
                  </i>
                  <span v-if="item.uiState === 'end'" class="status end">{{
                      $t('ab.report.default.cvr.endByPvLimit')
                    }}</span>
                  <span
                    v-if="item.uiState === 'scheduled'"
                    class="status scheduled"
                  >{{ $t('ab.report.default.cvr.scheduledRun') }}</span
                  >
                  <span
                    v-if="item.uiState === 'analyzing'"
                    class="status analyzing"
                  >{{ $t('ab.report.default.cvr.analyzing') }}</span
                  >
                  <span
                    v-if="item.uiState === 'deleted'"
                    class="status delete"
                  >{{ $t('ab.report.default.cvr.deleted') }}</span
                  >
                  <span v-if="item.uiState === 'stop'" class="status stop">{{
                      $t('ab.report.default.cvr.stop')
                    }}</span>
                  <span
                    v-if="item.uiState === 'tempstop'"
                    class="status tempstop"
                  >{{ $t('ab.report.default.cvr.stop') }}</span
                  >
                </div>
                <div class="info-title__wrap">
                  <i
                    v-if="item.uiState !== 'deleted'"
                    :class="{ disabled: item.uiState === 'scheduled' }"
                    class="icon icon--common-page-link clipboard"
                    @click="onViewApplyClick(item)"
                  ></i>
                  <i v-if="item.bAB" class="icon icon--ab-test-exist ab"></i>
                  <span class="title">{{ item.pageName }}</span>
                </div>
                <div class="url__wrap">
                  <a
                    :href="item | applyUrl"
                    class="link_to_site"
                    target="_blank"
                  >
                    <i
                      v-if="item.uiState !== 'deleted'"
                      class="icon icon--common-page-link-blue clipboard"
                    ></i>
                  </a>
                  <div v-if="item.showToastLayer" class="content__toast">
                    <span>{{ $t('common.trackingCode.copied') }}</span>
                    <i class="icon icon--check-green-size16"></i>
                  </div>
                  <div class="textarea">
                    <span @click="copyCode($event, index)">
                      {{ item.url }}
                    </span>
                  </div>
                </div>
              </div>
              <table :class="{ deletedTable: item.uiState === 'deleted' }">
                <colgroup>
                  <col width="23%" />
                  <col width="*" />
                  <col width="23%" />
                </colgroup>
                <thead>
                <tr>
                  <th class="th__a">
                    {{ $t('ab.report.default.cvr.label.aPageTarget') }}
                  </th>
                  <th class="th__improve">
                    {{ $t('ab.report.default.cvr.label.improvement') }}
                  </th>
                  <th class="th__b">
                    {{ $t('ab.report.default.cvr.label.bPageTarget') }}
                  </th>
                </tr>
                </thead>
                <tbody v-if="targetData.length">
                <tr>
                  <td :class="item.compare" class="td__a-value">
                    {{ item.a | fixed(1) }} %
                  </td>
                  <td class="td__separate">
                    <div>
                        <span class="a-bar"
                        ><i
                          :style="{
                              width: conversionRateTable(item.a) + '%'
                            }"
                        ></i>
                        </span>
                      <span class="divide"></span>
                      <span class="b-bar"
                      ><i
                        :style="{
                              width: conversionRateTable(item.b) + '%'
                            }"
                      ></i>
                        </span>
                    </div>
                  </td>
                  <td :class="item.compare" class="td__b-value">
                    {{ item.b | fixed(1) }} %
                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="3">-</td>
                </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </section>

      <ABSummary
        ref="summaryVue"
        :aAnalyticsData="aAnalyticsData"
        :aHeatmapData="aHeatmapData || {}"
        :abTypes="abTypes"
        :bAnalyticsData="bAnalyticsData"
        :bHeatmapData="bHeatmapData || {}"
        @getSummary="getSummary"
      />

      <!-- conversion rate top5 -->
      <section v-if="abTestType === 'url'" class="content__conversion-rate">
        <p class="title">{{ $t('ab.report.default.cvr.title') }}</p>
        <div class="box-layout">
          <table>
            <colgroup>
              <col width="23%" />
              <col width="*" />
              <col width="23%" />
            </colgroup>
            <thead>
            <tr>
              <th class="th__a">
                {{ $t('ab.report.default.cvr.label.aPage') }}
              </th>
              <th class="th__improve">
                {{ $t('ab.report.default.cvr.label.improvement') }}
              </th>
              <th class="th__b">
                {{ $t('ab.report.default.cvr.label.bPage') }}
              </th>
            </tr>
            </thead>
            <tbody v-if="conversionList.length">
            <tr v-for="(item, index) in conversionList" :key="index">
              <td :class="item.compare" class="td__a-value">
                {{ item.a.conversion }} %
              </td>
              <td class="td__separate">
                <div>
                  <a
                    :href="getConversionUrl(item.url, applyData.hostname)"
                    target="_blank"
                  >
                    {{ getConversionUrl(item.url, applyData.hostname) }}
                  </a>
                </div>
                <div>
                  <div class="bar--wrap">
                      <span class="a-bar"
                      ><i :style="{ width: item.a.chartPercentage + '%' }">
                        </i
                        ></span>
                    <span class="divide"></span>
                    <span class="b-bar"
                    ><i :style="{ width: item.b.chartPercentage + '%' }"></i
                    ></span>
                  </div>
                </div>
              </td>
              <td :class="item.compare" class="td__b-value">
                {{ item.b.conversion }} %
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="3">-</td>
            </tr>
            </tbody>
          </table>
        </div>
      </section>

      <!-- click per pv -->
      <section v-if="abTestType === 'url'" class="content__click-per-pv">
        <p class="title">{{ $t('ab.report.default.clickPerPv.title') }}</p>
        <div class="box-layout">
          <table>
            <colgroup>
              <col width="36%" />
              <col width="*" />
              <col width="36%" />
            </colgroup>
            <thead>
            <tr>
              <th class="th__a">
                {{ $t('ab.report.default.clickPerPv.label.aPage') }}
              </th>
              <th class="th__ranking">{{ $t('common.rank') }}</th>
              <th class="th__b">
                {{ $t('ab.report.default.clickPerPv.label.bPage') }}
              </th>
            </tr>
            </thead>
            <tbody v-if="clickList.length">
            <tr v-for="(item, index) in clickList" :key="index">
              <td class="td__a-value">
                <figure v-if="item['a']">
                  <crop-image
                    :height="item['a'].height"
                    :imageHeight="imageData.a.height"
                    :imageWidth="imageData.a.width"
                    :maxHeight="42"
                    :maxWidth="300"
                    :offset="{ x: item['a'].left, y: item['a'].top }"
                    :url="imageData.a.url"
                    :width="item['a'].width"
                  />
                </figure>
                <span v-else>-</span>
              </td>
              <td class="td__ranking">
                <div class="ranking--wrap">
                  <div class="a-page-value">
                      <span v-if="item['a']" :class="item['compare']">
                        {{ aClickPerPv(item['a']) | fixed(2) | clicks }}
                      </span>
                    <span v-else>-</span>
                  </div>
                  <div class="rank">
                    <span>{{ (index + 1) | rank }}</span>
                  </div>
                  <div class="b-page-value">
                      <span v-if="item['b']" :class="item['compare']">
                        {{ bClickPerPv(item['b']) | fixed(2) | clicks }}
                      </span>
                    <span v-else>-</span>
                  </div>
                </div>
              </td>
              <td class="td__b-value">
                <figure v-if="item['b']">
                  <crop-image
                    :height="item['b'].height"
                    :imageHeight="imageData.b.height"
                    :imageWidth="imageData.b.width"
                    :maxHeight="42"
                    :maxWidth="300"
                    :offset="{ x: item['b'].left, y: item['b'].top }"
                    :url="imageData.b.url"
                    :width="item['b'].width"
                  />
                </figure>
                <span v-else>-</span>
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td class="td__a-value">-</td>
              <td class="td__ranking">
                <div class="ranking--wrap">
                  <div class="a-page-value">-</div>
                  <div class="rank">-</div>
                  <div class="b-page-value">-</div>
                </div>
              </td>
              <td class="td__b-value">-</td>
            </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
    <slot v-if="!isLoading" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import {
  getHeatmapData,
  getAnalyticsData,
  getCaptureImageUrl,
  getBasicInfoData,
  getTestResult
} from '@/api/report'
import { normalizeClickData } from '@/libs/report-data-normalizer'
import { getPercentage, getDefaultDeviceAB, isAiDisabledAccount } from '@/libs/utils'
import { getConversionUrl } from '@/libs/analytics-helper'
import ABSummary from '@/components/report-ab/ABSummary'
import CropImage from '@/components/ui/CropImage'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import { getABTargetResult } from '@/api/abtest'
import { format, parse } from 'date-fns'
import UiTooltip from '@/components/ui/UiTooltip'
import NodePath from './NodePath'
import ABreportResultPath from '@/components/report-ab/ABreportResultPath.vue'
import axios from 'axios'
import { connect } from '@/api/ai'

const EVENT_SOURCE_NEW = 1 // 0001
const EVENT_SOURCE_RETURN = 2 // 0011
const EVENT_SOURCE_ALL = 3 // 0011

export default {
  components: {
    ABreportResultPath,
    ABSummary,
    CropImage,
    UiLoadingCircle,
    UiTooltip,
    NodePath
  },
  props: ['abList', 'aData', 'bData'],
  data () {
    return {
      pathValue: null,
      pathWidth: 0,
      pathHeight: 0,
      abTestType: 'url',
      isLoading: true,
      cancelTokenSource: false,
      isResultLoading: true,
      reportData: [],
      summaryData: null,
      timestamp: new Date().getTime(),
      targetData: [],
      targetDropOff: {},
      targetEtc: {},
      analyticsData: {
        a: null,
        b: null
      },
      heatmapData: {
        a: null,
        b: null
      },
      imageData: {
        a: null,
        b: null
      },
      coordData: {
        a: [],
        b: []
      },
      figHeight: 0,
      pathApostion: 0,
      pathBpostion: 0,
      conversionList: [],
      clickList: [],
      clickTextList: [
        {
          aText: 'test1',
          aPercent: 39.4,
          bText: 'test1',
          bPercent: 39.4,
          rateChange: 20
        },
        {
          aText: 'test1',
          aPercent: 39.4,
          bText: 'test1',
          bPercent: 39.4,
          rateChange: 20
        }
      ],
      currentDevice: 'desktop',
      deviceItems: [
        {
          key: 'desktop',
          text: 'Desktop'
        },
        {
          key: 'tablet',
          text: 'Tablet'
        },
        {
          key: 'phone',
          text: 'Phone'
        }
      ],
      isFlowList: true,
      showTargetTooltip: false,
      conversionTargetData: [],
      prevStrockWidth: [],
      groupHeight: [],
      divisionHeight: 0,
      AHeight: 0,
      BHeight: 0,
      APrev: [],
      BPrev: [],
      eventSourceButtons: [
        {
          key: 'new',
          t: 'heatmap.cvr_exit.new'
        },
        {
          key: 'return',
          t: 'heatmap.cvr_exit.revisit'
        }
      ],
      device: 'desktop',
      segmentCLick: {
        device: false,
        eventsource: false
      },
      eventSource: 'all',
      entirePv: 0,
      defaultDeviceList: [],
      testResultData: null
    }
  },
  computed: {
    ...mapState(['reportPeriod', 'applyData', 'userData']),
    ...mapGetters(['abUsedTraffic', 'lnbMinimize']),
    isAiDisabled () {
      return isAiDisabledAccount(this.userData)
    },
    dataKey () {
      return [this.summaryData]
    },
    aid () {
      return this.$route.params.aid
    },
    abAid () {
      return this.$route.params.abAid
    },
    abData () {
      return {
        a: this.aData,
        b: this.bData
      }
    },
    aAnalyticsData () {
      return this.analyticsData.a
    },
    bAnalyticsData () {
      return this.analyticsData.b
    },
    aHeatmapData () {
      return this.heatmapData.a
    },
    bHeatmapData () {
      return this.heatmapData.b
    },
    abTypes () {
      return ['a', 'b']
    },
    abTraffic () {
      return this.bData.traffic
    },
    abHalfTraffic () {
      return this.abTraffic / 2
    },
    trafficBarWidth () {
      return this.abHalfTraffic
    },
    trafficSummary () {
      const abTraffic = this.abTraffic
      const abHalfTraffic = this.abHalfTraffic
      const pageLabel = this.$t('common.page')
      const excludeText =
        abTraffic !== 100
          ? `+ ${this.$t('ab.report.default.excludeTest')}(${100 - abTraffic}%)`
          : ''
      return `A ${pageLabel}(${abHalfTraffic}%) + B ${pageLabel}(${abHalfTraffic}%) ${excludeText} = 100%`
    },
    eventSourceFlag () {
      switch (this.eventSource) {
        case 'new':
          return EVENT_SOURCE_NEW
        case 'return':
          return EVENT_SOURCE_RETURN
        case 'all':
          return EVENT_SOURCE_ALL
        default:
          throw new Error(`invalid eventSource: ${this.eventSource}`)
      }
    },
    flagNew () {
      return this.eventSourceFlag & EVENT_SOURCE_NEW
    },
    flagReturn () {
      return this.eventSourceFlag & EVENT_SOURCE_RETURN
    },
    bMobile () {
      return this.applyData.bMobile
    },
    deviceList () {
      if (this.bMobile) {
        return ['phone']
      } else {
        return ['desktop', 'tablet', 'phone']
      }
    },
    goLink () {
      const lang = this.$i18n.locale

      if (lang === 'en') {
        return 'https://forum.beusable.net/en/solomon/post/1859'
      } else if (lang === 'ja') {
        return 'https://forum.beusable.net/ja/solomon/post/1858'
      } else {
        return 'https://forum.beusable.net/ko/solomon/post/1857'
      }
    },
    aClickPerPv () {
      return (value) => {
        if (!isNaN(value.clickPerPv)) {
          return value.clickPerPv
        } else {
          return value.tapPerPv
        }
      }
    },
    bClickPerPv () {
      return (value) => {
        if (!isNaN(value.clickPerPv)) {
          return value.clickPerPv
        } else {
          return value.tapPerPv
        }
      }
    },
    resultTypeClass () {
      if (this.isResultLoading || !this.reportData[0]) return ''

      const type = this.reportData[0]

      if (type === 'check') return 'check-type'
      if (type === 'a') return 'a-type'
      if (type === 'b') return 'b-type'

      return ''
    }
  },
  methods: {
    getAvgDurationChartData () {
      const mapFn = (item) => {
        return Number((item.sessTime / 1000).toFixed(1))
      }
      return {
        a: this.aAnalyticsData.daily.map(mapFn),
        b: this.bAnalyticsData.daily.map(mapFn)
      }
    },
    getExitRateChartData () {
      const mapFn = (item) => {
        return getPercentage(item.pv - item.cvr, item.pv, 1)
      }
      return {
        a: this.aAnalyticsData.daily.map(mapFn),
        b: this.bAnalyticsData.daily.map(mapFn)
      }
    },
    getClickPvRateChartData () {
      const mapFn = (item) => {
        return getPercentage(item.clickPv, item.pv, 1)
      }
      return {
        a: this.aAnalyticsData.daily.map(mapFn),
        b: this.bAnalyticsData.daily.map(mapFn)
      }
    },
    getConversionChartData () {
      const mapFn = (item) => {
        return getPercentage(item.cvr, item.pv, 1)
      }
      return {
        a: this.aAnalyticsData.daily.map(mapFn),
        b: this.bAnalyticsData.daily.map(mapFn)
      }
    },
    getClickPerPvChartData () {
      const mapFn = (item, dailyClicks) => {
        const dateStr = format(parse(item.day), 'YYYY-MM-DD')
        if (!item.pv || !dailyClicks[dateStr]) {
          return 0
        }
        // todo: check calculation
        return Math.round((dailyClicks[dateStr] / item.pv) * 10) / 10
      }

      let aDailyClicks = 0
      if (this.aHeatmapData) {
        aDailyClicks = this.aHeatmapData.dailyClicks || this.aHeatmapData.dailyTabs || 0
      }

      let bDailyClicks = 0
      if (this.bHeatmapData) {
        bDailyClicks = this.bHeatmapData.dailyClicks || this.bHeatmapData.dailyTabs || 0
      }

      return {
        a: this.aAnalyticsData.daily.map((item) => mapFn(item, aDailyClicks)),
        b: this.bAnalyticsData.daily.map((item) => mapFn(item, bDailyClicks))
      }
    },
    async imageExistCheck (url) {
      const http = new XMLHttpRequest()
      http.open('GET', url, false)
      http.send()
      return http.status !== 404
    },
    getSummary (summary) {
      this.summaryData = summary
    },
    getReformData () {
      const aid = this.$route.params.aid
      const abid = this.$route.params.abAid
      const fullData = this.analyticsData
      const summary = this.summaryData

      const aLinkConversion = {}
      const bLinkConversion = {}

      this.conversionList.forEach((item, index) => {
        const key = `top${index + 1}`

        aLinkConversion[key] = {
          url: item.url,
          rate: item.a.conversion
        }

        bLinkConversion[key] = {
          url: item.url,
          rate: item.b.conversion
        }
      })

      const aElemConversion = {}
      const bElemConversion = {}

      this.clickList.forEach((item, index) => {
        const key = `top${index + 1}`

        // a 처리
        if (!item.a) {
          aElemConversion[key] = {
            selector: null,
            clicks: null
          }
        } else {
          aElemConversion[key] = {
            selector: item.a.selector,
            clicks: item.a.clickPerPv
          }
        }

        // b 처리
        if (!item.b) {
          bElemConversion[key] = {
            selector: null,
            clicks: null
          }
        } else {
          bElemConversion[key] = {
            selector: item.b.selector,
            clicks: item.b.clickPerPv
          }
        }
      })

      let aCat = ''
      let bCat = ''
      let categorys = []
      switch (this.bData.abTestType) {
        case 'url':
          aCat = this.aData.url
          bCat = this.bData.url
          categorys = [
            {
              A: aCat,
              B: bCat,
              CODE: ''
            }
          ]
      }

      const simplifiedData = this.targetData
        .filter((item) => item.target !== 'etc' && item.target !== 'dropped')
        .map((item) => ({
          aid: item.target,
          pageName: item.pageName,
          matchType: item.matchType,
          url: item.url,
          ratio: {
            A: Number(Math.round(`${item.a}e${1}`) + `e-${1}`).toFixed(1),
            B: Number(Math.round(`${item.b}e${1}`) + `e-${1}`).toFixed(1)
          }
        }))
      const matchedItem = this.abList.find((item) => item.aid === abid)

      const clickPerPv = this.getClickPerPvChartData()
      const clickPvRate = this.getClickPvRateChartData()
      const clickExitRate = this.getExitRateChartData()
      const avgDuration = this.getAvgDurationChartData()

      let reformData = {
        report: {
          aid: aid,
          reportName: fullData.aInfo.pageName,
          reportUrl: fullData.aInfo.url,
          state: this.aData.state
        },
        abReport: {
          abid: abid,
          abReportName: fullData.bInfo.pageName,
          abReportState: this.bData.state,
          traffic: this.bData.traffic,
          testType: this.bData.abTestType,
          period: {
            timezone: this.bData.timezoneName,
            startDate: matchedItem.startDate,
            endDate: matchedItem.endDate
          },
          abReportType: {
            category: categorys
          },
          target: simplifiedData
        },
        abReportResult: {
          segments: {
            period: {
              start: this.reportPeriod.start,
              end: this.reportPeriod.end
            },
            device: {
              deviceType: this.device,
              deviceRatio: this.getDevicePvPercentage(this.device)
            },
            existing: ['new', 'return'].includes(this.eventSource)
              ? this.eventSource
              : 'all'
          },
          A: {
            summary: {
              pageViews: {
                total: this.aAnalyticsData.pvTotal,
                daily: this.aAnalyticsData.daily.map((entry) => entry.pv)
              },
              clickPerPv: {
                total: summary.clickPerPv.a,
                daily: clickPerPv.a
              },
              clickPvRate: {
                total: summary.clickPvRate.a,
                daily: clickPvRate.a
              },
              clickExitRate: {
                total: summary.exitRate.a,
                daily: clickExitRate.a
              },
              avgDuration: {
                total: summary.avgDuration.a,
                daily: avgDuration.a
              },
              clickConversionRate: {
                total: summary.conversion.a
              }
            },
            linkClickConversionRateTop5:
              this.bData.abTestType === 'url' ? aLinkConversion : null,
            clicksPerPvTop5ByElement:
              this.bData.abTestType === 'url' ? aElemConversion : null
          },
          B: {
            summary: {
              pageViews: {
                total: this.bAnalyticsData.pvTotal,
                daily: this.bAnalyticsData.daily.map((entry) => entry.pv)
              },
              clickPerPv: {
                total: summary.clickPerPv.b,
                daily: clickPerPv.b
              },
              clickPvRate: {
                total: summary.clickPvRate.b,
                daily: clickPvRate.b
              },
              clickExitRate: {
                total: summary.exitRate.b,
                daily: clickExitRate.b
              },
              avgDuration: {
                total: summary.avgDuration.b,
                daily: avgDuration.b
              },
              clickConversionRate: {
                total: summary.conversion.b
              }
            },
            linkClickConversionRateTop5:
              this.bData.abTestType === 'url' ? bLinkConversion : null,
            clicksPerPvTop5ByElement:
              this.bData.abTestType === 'url' ? bElemConversion : null
          }
        }
      }
      return reformData
    },
    getTestResultData () {
      if (this.isAiDisabled) {
        this.isResultLoading = false
        this.reportData = []
        return
      }
      this.isResultLoading = true
      const result = JSON.stringify(this.getReformData())
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('이전 요청 취소됨')
      }
      this.cancelTokenSource = axios.CancelToken.source()
      const params = {
        category: 'ab-test',
        lang: this.$i18n.locale,
        prompt: result,
        streaming: false
      }
      let resultData
      getTestResult(params, this.cancelTokenSource.token)
        .then((data) => {
          resultData = data.data.data
            .split(/\n?\*\n?/g)
            .flatMap(block => {
              return block
                .split('\n')
                .map(s => {
                  let trimmed = s.trim().replace(/\n/g, '<br />')
                  if (/_result/i.test(trimmed)) {
                    trimmed = trimmed.toLowerCase()
                  }

                  trimmed = trimmed
                    .replace(/\[([^\]]*?)_result\]/gi, '$1')
                    .replace(/_result/gi, '')
                    .replace(/[\[\]【】]/g, '')

                  return trimmed.trim()
                })
                .filter(Boolean)
            })

          const reasonStart = resultData[1] && !resultData[1].includes('Next action') ? 1 : -1
          const nextActionStart = resultData.findIndex(s => s.includes('Next action'))

          const reasonText =
            reasonStart !== -1
              ? resultData.slice(reasonStart + 1, nextActionStart !== -1 ? nextActionStart : undefined).join('<br />')
              : ''

          const nextActionText =
            nextActionStart !== -1
              ? resultData.slice(nextActionStart + 1).join('<br />')
              : ''

          this.reportData = [resultData[0], reasonText, nextActionText]
        })
        .finally(() => {
          this.isResultLoading = false
        })
        .catch((err) => {
          if (!axios.isCancel(err)) {
            console.error(err)
            this.isResultLoading = false
          } else {
            this.reportData = []
            this.isResultLoading = true
          }
        })
    },
    onViewApplyClick (item) {
      if (item.uiState !== 'scheduled') {
        let defaultRouterName = 'heatmap-report'
        if (this.isABPlan) {
          defaultRouterName = 'ab.list'
        }
        const to = this.$router.resolve({
          name: defaultRouterName,
          params: { aid: item.aid }
        })
        window.open(to.href, '_blank')
      }
    },
    getTargetResult (targetParam) {
      return getABTargetResult(targetParam)
        .then((res) => {
          return res
        })
        .catch((e) => {
          return []
        })
    },
    loadData () {
      const basicInfoDataParam = {
        aid: this.abAid,
        startDate: this.reportPeriod.start,
        endDate: this.reportPeriod.end,
        abTestType: this.abTestType
      }
      const getBasicInfoDataParamA = {
        ...basicInfoDataParam,
        bab: false
      }
      const getBasicInfoDataParamB = {
        ...basicInfoDataParam,
        bab: true
      }
      return getBasicInfoData(getBasicInfoDataParamA)
        .then((resA) => {
          return getBasicInfoData(getBasicInfoDataParamB).then((resB) => {
            const infoDataA = resA
            const infoDataB = resB
            this.entirePv = infoDataA.pv + infoDataB.pv
            this.defaultDeviceList = getDefaultDeviceAB(infoDataA, infoDataB)
            if (this.segmentCLick.device) {
              this.segmentCLick.device = false
              this.eventSource = 'all'
            } else if (this.segmentCLick.eventsource) {
              this.segmentCLick.eventsource = false
            } else {
              this.device = this.defaultDeviceList[0]['device']
              this.eventSource = 'all'
            }
            const analyticsParam = {
              aid: this.abAid,
              device: this.device,
              startDate: this.reportPeriod.start,
              endDate: this.reportPeriod.end,
              abTestType: this.abTestType,
              existing:
                this.eventSource === 'new'
                  ? false
                  : this.eventSource === 'return'
                    ? true
                    : null
            }
            const analyticsParamA = {
              ...analyticsParam,
              bab: false
            }
            const analyticsParamB = {
              ...analyticsParam,
              bab: true
            }
            const heatmapParam = {
              event: this.device === 'phone' ? 'tab' : 'click',
              aid: this.abAid,
              device: this.device,
              startDate: this.reportPeriod.start,
              endDate: this.reportPeriod.end,
              refer: 'all',
              hidden: false,
              abTestType: this.abTestType,
              existing:
                this.eventSource === 'new'
                  ? false
                  : this.eventSource === 'return'
                    ? true
                    : null
            }
            const heatmapParamA = {
              ...heatmapParam,
              bab: false
            }
            const heatmapParamB = {
              ...heatmapParam,
              bab: true
            }

            const targetParam = {
              abid: this.abAid,
              device: this.device,
              startDate: this.reportPeriod.start,
              endDate: this.reportPeriod.end,
              existing:
                this.eventSource === 'new'
                  ? false
                  : this.eventSource === 'return'
                    ? true
                    : null
            }

            if (!analyticsParamA.aid || !analyticsParamB.aid) return

            return Promise.all([
              getAnalyticsData(analyticsParamA),
              getAnalyticsData(analyticsParamB),
              getHeatmapData(heatmapParamA),
              getHeatmapData(heatmapParamB),
              this.getTargetResult(targetParam)
            ])
              .then((result) => {
                this.analyticsData.a = result[0].analytics_data
                this.analyticsData.aInfo = result[0].apply_data
                this.analyticsData.b = result[1].analytics_data
                this.analyticsData.bInfo = result[1].apply_data
                this.heatmapData.a = result[2]
                this.heatmapData.b = result[3]
                let targetData = []
                if (result[4]) {
                  targetData = result[4]
                  this.setTargetData(targetData)
                }
                this.setCoordsData()
                  .then(() => {
                    this.setConversionList()
                    this.setClickList()
                    this.isLoading = false
                    this.$emit('loading', this.isLoading)
                  })
                  .catch((err) => {
                    throw err
                  })
              })
              .catch((err) => {
                throw err
              })
          })
        })

        .catch((err) => {
          console.error(err)
          this.isLoading = false
        })
    },
    async setTargetData (targetData) {
      this.targetData = []
      const now = format(new Date())
      const installDate = format(new Date().getTime() - 1 * 11 * 60 * 60 * 1000)
      const pvTotal = {
        a: this.analyticsData.a.pvTotal,
        b: this.analyticsData.b.pvTotal
      }
      const ratio = []
      const tableRatio = []
      for (const target of targetData) {
        target.conversion.forEach((item) => {
          const abkey = item.bAB ? 'b' : 'a'
          target[abkey] = pvTotal[abkey]
            ? (item.value / pvTotal[abkey]) * 100
            : 0
        })
        if (target.deleted === true) {
          target.uiState = 'deleted'
        } else if (target.startDate > now) {
          target.uiState = 'scheduled'
        } else if (
          target.installDate > installDate &&
          target.installDate < now
        ) {
          target.uiState = 'analyzing'
        } else if (
          target.endDate < now &&
          target.state === 'endByAnalysisDate'
        ) {
          target.uiState = 'end'
        } else if (target.creditEmpty === 'true') {
          target.uiState = 'tempstop'
        } else if (target.state === 'stop') {
          target.uiState = 'stop'
        } else {
          target.uiState = 'run'
        }
        target.showTargetTooltip = false

        target.compare = target.a > target.b ? 'largeA' : 'largeB'
        if (target.compare === 'largeA') {
          target.minValue = (target.b / target.a) * 100
        } else {
          target.minValue = (target.a / target.b) * 100
        }

        if (target.state) {
          target.aid = target.target
          target.imgSrc = !target.deleted
            ? await this.getImagePath(target.target)
            : '../../../assets/img/arrow/no-img-2.svg'

          this.targetData.push(target)
        }

        if (target.target === 'dropped') {
          this.targetDropOff = target
        }

        if (target.target === 'etc') {
          target.a = 0
          target.b = 0
          this.targetEtc = target
        }

        if (target.target !== 'dropped') {
          ratio.push(target.a, target.b)
        }

        if (target.target !== 'dropped' && target.target !== 'etc') {
          tableRatio.push(target.a, target.b)
        }
      }
      this.maxRatio = Math.max.apply(null, ratio)
      this.minRatio = Math.min.apply(null, ratio)
      this.maxTableRatio = Math.max.apply(null, tableRatio)
      for (const item of targetData) {
        if (item.target !== 'dropped') {
          this.AHeight += this.conversionRate(item.a)
          this.BHeight += this.conversionRate(item.b)
          this.APrev.push(this.conversionRate(item.a))
          this.BPrev.push(this.conversionRate(item.b))
        }
      }
      if (this.targetDropOff.a === 0 && this.targetDropOff.b === 0) {
        this.targetDropOff.AState = 'small'
        this.targetDropOff.BState = 'small'
      } else {
        if (this.targetDropOff.a) {
          if (this.targetDropOff.a < 30) {
            this.targetDropOff.AState = 'small'
          } else if (this.targetDropOff.a < 70) {
            this.targetDropOff.AState = 'medium'
          } else {
            this.targetDropOff.AState = 'large'
          }
        }
        if (this.targetDropOff.b) {
          if (this.targetDropOff.b < 30) {
            this.targetDropOff.BState = 'small'
          } else if (this.targetDropOff.b < 70) {
            this.targetDropOff.BState = 'medium'
          } else {
            this.targetDropOff.BState = 'large'
          }
        }
      }

      this.conversionTargetData = this.targetData.concat(this.targetEtc)

      let heightcheck = 0
      if (this.targetData.length > 0) {
        this.timeout = setInterval(() => {
          if (
            this.$refs.nodewrap.offsetHeight ===
            this.$refs.targetwrap.offsetHeight &&
            this.$refs.nodewrap.offsetHeight > 350
          ) {
            heightcheck++
          }

          this.onCalcGroupHeight()

          if (heightcheck === 5) {
            clearInterval(this.timeout)
            console.log('all set!')
          }
        }, 200)
      }
    },
    captureImageParamsForTarget (aid, device) {
      return {
        aid: aid,
        device: device,
        startDate: this.reportPeriod.start,
        endDate: this.reportPeriod.end
      }
    },
    async getImagePath (aid) {
      let deviceList = ['desktop', 'phone', 'tablet']
      if (this.applyData.bMobile) {
        deviceList = ['phone', 'desktop', 'tablet']
      }

      let imageUrl = ''

      let isValidImg = false

      for (const device of deviceList) {
        if (!isValidImg) {
          const params = this.captureImageParamsForTarget(aid, device)
          const imgUrl = await getCaptureImageUrl(params, new Date().getTime())

          if (imgUrl && (await this.imageExistCheck(imgUrl))) {
            imageUrl = imgUrl
            isValidImg = true
          }
        }
      }

      return imageUrl
    },
    captureImageParams (abType) {
      const captureAid = abType === 'a' ? this.aid : this.abAid
      return {
        aid: captureAid,
        device: this.device,
        startDate: this.reportPeriod.start,
        endDate: this.reportPeriod.end,
        timestamp: this.timestamp
      }
    },
    setCoordsData () {
      return Promise.all([
        this.getCaptureImageData(this.captureImageParams('a'), this.timestamp),
        this.getCaptureImageData(this.captureImageParams('b'), this.timestamp)
      ]).then((result) => {
        this.imageData = {
          a: result[0],
          b: result[1]
        }
        for (const abType of this.abTypes) {
          if (this.imageData[abType] && this.heatmapData[abType]) {
            const data = this.heatmapData[abType]
            const pvTotal = this.analyticsData[abType].pvTotal
            const imageData = this.imageData[abType]
            const coordsData = normalizeClickData(
              data,
              pvTotal,
              this.device,
              imageData.width,
              imageData.height
            )
            this.coordData[abType] = coordsData
          } else {
            this.coordData[abType] = {}
          }
        }
      })
    },
    getCaptureImageData (params, timestamp) {
      return new Promise((resolve, reject) => {
        getCaptureImageUrl(params, timestamp)
          .then((imageUrl) => {
            if (!imageUrl) {
              return resolve(null)
            }
            const img = document.createElement('img')
            img.addEventListener('load', (event) => {
              const el = event.target
              resolve({
                url: imageUrl,
                width: el.width,
                height: el.height
              })
            })
            img.addEventListener('error', (e) => {
              console.error('이미지 로드 실패:', imageUrl)
              resolve(null)
            })
            img.src = imageUrl
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    setConversionList () {
      const data = {}
      let maxConversion = 0

      for (const abType of this.abTypes) {
        for (const item of this.analyticsData[abType].cvr) {
          if (!data[item.cvr]) {
            data[item.cvr] = {
              a: 0,
              b: 0
            }
          }
          data[item.cvr][abType] += item.count
        }
      }

      const items = Object.entries(data)
        .map(([url, item]) => {
          const aConversion = getPercentage(
            item.a,
            this.analyticsData.a.pvTotal,
            1
          )
          const bConversion = getPercentage(
            item.b,
            this.analyticsData.b.pvTotal,
            1
          )
          maxConversion = Math.max(maxConversion, aConversion, bConversion)

          return {
            url,
            compare: '',
            a: {
              count: item.a,
              conversion: aConversion
            },
            b: {
              count: item.b,
              conversion: bConversion
            },
            conversionDiff: Math.abs(aConversion - bConversion)
          }
        })
        .sort((a, b) => {
          return b.conversionDiff - a.conversionDiff
        })
        .slice(0, 5)

      for (const item of items) {
        if (item.a.conversion !== item.b.conversion) {
          item.compare =
            item.a.conversion > item.b.conversion ? 'largeA' : 'largeB'
        }
        item.a.chartPercentage = getPercentage(
          item.a.conversion,
          maxConversion,
          1
        )
        item.b.chartPercentage = getPercentage(
          item.b.conversion,
          maxConversion,
          1
        )
      }
      this.conversionList = items
    },
    setClickList () {
      const items = []
      const sortFn = (a, b) => {
        if (b.tabCount) {
          return b.tabCount - a.tabCount
        } else {
          return b.clickCount - a.clickCount
        }
      }

      let aItems = []
      let bItems = []

      if (this.coordData.a.coords) {
        aItems = Object.values(this.coordData.a.coords).sort(sortFn)
      }

      if (this.coordData.b.coords) {
        bItems = Object.values(this.coordData.b.coords).sort(sortFn)
      }

      let itemSize = Math.max(aItems.length, bItems.length)
      itemSize = Math.min(itemSize, 5)

      for (let i = 0; i < itemSize; i++) {
        const item = {
          a: aItems[i],
          b: bItems[i],
          compare: ''
        }

        items.push(item)
      }
      this.clickList = items
    },
    onChangeView (str) {
      if (str === 'flow') {
        this.isFlowList = true
      } else {
        this.isFlowList = false
      }
    },
    copyCode (event, idx) {
      const targetDom = event.target
      let range = document.createRange()
      range.setStartBefore(targetDom)
      range.setEndAfter(targetDom)
      let sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
      document.execCommand('copy')
      this.$set(this.targetData, idx, {
        ...this.targetData[idx],
        showToastLayer: true
      })
      setTimeout(() => {
        this.$set(this.targetData, idx, {
          ...this.targetData[idx],
          showToastLayer: false
        })
      }, 5000)
    },
    conversionRate (ratio) {
      if (ratio === 0 || NaN) {
        return 1
      } else if (ratio === this.maxRatio) {
        return 10
      } else if (ratio === this.minRatio) {
        return 2
      } else {
        const conversionRatio = (ratio / this.maxRatio) * 10
        return conversionRatio
      }
    },
    conversionRateTable (ratio) {
      if (ratio === 0) {
        return 0
      } else if (ratio === this.maxTableRatio) {
        return 100
      } else {
        const conversionRatio = (ratio / this.maxRatio) * 100
        return conversionRatio
      }
    },
    onCalcGroupHeight () {
      const heightList = []
      let divisionHeight = 0
      this.targetData.forEach((item, idx) => {
        heightList.push(this.$refs['targetList'][idx].offsetHeight)
        divisionHeight += this.$refs['targetList'][idx].offsetHeight
      })
      heightList.push(this.$refs.etc.offsetHeight)
      this.groupHeight = heightList
      this.divisionHeight = divisionHeight
    },
    async setEventSource (source) {
      let flag
      this.segmentCLick.eventsource = true
      if (source === 'new') {
        flag = this.flagReturn | (this.flagNew ^ EVENT_SOURCE_NEW)
      } else {
        flag = this.flagNew | (this.flagReturn ^ EVENT_SOURCE_RETURN)
      }

      if (!flag) {
        flag = source === 'new' ? EVENT_SOURCE_RETURN : EVENT_SOURCE_NEW
      }

      let newSource

      switch (flag) {
        case EVENT_SOURCE_NEW:
          newSource = 'new'
          break
        case EVENT_SOURCE_RETURN:
          newSource = 'return'
          break
        case EVENT_SOURCE_ALL:
          newSource = 'all'
          break
      }
      this.eventSource = newSource
      await this.loadData()
      await this.getTestResultData()
    },
    getEventSourceClass (source) {
      // guide
      let value = source === 'new' ? this.flagNew : this.flagReturn
      return { on: !!value }
    },
    async onDeviceChange (item) {
      this.device = item
      this.segmentCLick.device = true
      await this.loadData()
      await this.getTestResultData()
    },
    updatePathPosition () {
      if (this.$refs.resultBox) {
        const width = this.$refs.resultBox.offsetWidth

        const rectA = this.$refs.aHalfWidthBox[0].getBoundingClientRect()
        const rectB = this.$refs.resultBox.getBoundingClientRect()

        const startX = rectA.left + rectA.width / 2
        const endX = rectB.left + rectB.width / 2

        const boxDistance = endX - startX
        const baseDistance = 302
        const scaleRatio = boxDistance / baseDistance

        const maxX = 306 * scaleRatio
        const maxY = 60

        this.pathValue = `M${2 * scaleRatio} 2C ${11.5 * scaleRatio} 16 ${25 * scaleRatio} 30 ${58 * scaleRatio} 30
C ${100.8 * scaleRatio} 30 ${204 * scaleRatio} 30 ${240 * scaleRatio} 30
C ${276 * scaleRatio} 30 ${295.5 * scaleRatio} 46 ${304 * scaleRatio} 58`

        this.pathWidth = maxX
        this.pathHeight = maxY

        this.pathBpostion = (width / 2)
        this.pathApostion = (this.$refs.aHalfWidthBox[0].offsetWidth / 2)
      }
    },
    getDevicePvPercentage (item) {
      let pv = 0
      for (const device of this.defaultDeviceList) {
        if (this.entirePv > 0 && device.device === item && device.pv > 0) {
          const devicePv = device.pv
          pv = (devicePv / this.entirePv) * 100
        }
      }
      return pv
    },
    checkElement () {
      this.updatePathPosition()
    }
  },
  watch: {
    isResultLoading (val) {
      if (!val) {
        this.$nextTick(() => {
          this.updatePathPosition()
        })
      }
    },
    dataKey: {
      handler (newValue) {
        if (!newValue) return
        this.getTestResultData()
      },
      deep: true
    },
    reportPeriod (value) {
      this.isLoading = true
      this.loadData()
    },
    device (value) {
      // this.loadData()
    },
    lnbMinimize () {
      const appClassName = document.querySelector('#app').className
      if (this.lnbMinimize) {
        document.querySelector('#app').className =
          appClassName + ' app_min_1280'
      } else {
        document.querySelector('#app').className = appClassName.replace(
          'app_min_1280',
          ''
        )
      }
    }

  },
  async created () {
    await connect(true)
    this.abTestType = null
    if (this.bData.abTestType) {
      this.abTestType = this.bData.abTestType
    }
    this.getConversionUrl = getConversionUrl
    await this.loadData()
    const appClassName = document.querySelector('#app').className
    document.querySelector('#app').className = appClassName + ' app_min_1440'
  },
  mounted () {
    let boxWidth = 0

    this.timer = setInterval(() => {
      const boxInnerSpace = 145 // padding(25 + 25) + margin(20) + figure 이외의 offsetHeight(75)

      if (this.$refs.aHalfWidthBox) {
        const width = this.$refs.aHalfWidthBox[0].offsetWidth
        if (boxWidth !== width) {
          boxWidth = width
          this.figHeight = boxWidth * 0.8 - boxInnerSpace
        }
      }
    }, 100)

    window.addEventListener('resize', this.checkElement)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkElement)
    clearInterval(this.timer)
    clearInterval(this.timeout)
  }
}
</script>

<style lang="scss" scoped>
.ab-report__content {
  .box-layout {
    border-radius: 14px;
    background-color: #ffffff;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.08);
    padding: 25px;
  }

  section {
    &.device__select {
      .heatmap__control-bar-top {
        box-sizing: border-box;
        // border-bottom: 1px solid #ebebeb;
        display: flex;
        align-items: center;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        height: 62px;

        .heatmap__control__device {
          padding-right: 15px;
          white-space: nowrap;
          display: inline-block;
          width: 261px;
          height: 38px;
          border-radius: 20px;
          border: solid 1px #e0e0e0;
          background-color: #ffffff;
          box-sizing: border-box;
          position: relative;

          button {
            position: absolute;
            top: 0;
            width: 91px;
            height: 100%;
            border-radius: 20px;
            background-color: #fff;
            overflow: visible;

            & > span {
              vertical-align: middle;
            }

            &:hover:not(.on) .text {
              color: #444;
            }

            &:nth-of-type(1) {
              left: 0;

              &.on {
                left: -1px;
              }

              &:hover:not(.on) i.icon--device-desktop {
                background-image: url(../../assets/img/heatmap/heatmap_device_desktop_hover.svg);
              }
            }

            &:nth-of-type(2) {
              left: 50%;
              transform: translateX(-50%);

              &.on {
                top: -1px;
              }

              &:hover:not(.on) i.icon--device-tablet {
                background-image: url(../../assets/img/heatmap/heatmap_device_tablet_hover.svg);
              }
            }

            &:nth-of-type(3) {
              right: 0;

              &.on {
                right: -1px;
              }

              &:hover:not(.on) i.icon--device-phone {
                background-image: url(../../assets/img/heatmap/heatmap_device_phone_hover.svg);
              }
            }

            &:focus {
              z-index: 1;
            }

            &.on {
              top: -1px;
              height: 38px;
              box-shadow: 0 12px 10px -4px rgba(0, 0, 0, 0.2);
              background-color: $brandColor;
              z-index: 2;
              pointer-events: none;

              .text {
                color: #fff;
              }
            }

            i {
              vertical-align: middle;
              margin-right: 2px;
            }

            .text {
              font-size: 13px;
              font-weight: 500;
              color: #888888;
            }

            .percentage {
              display: inline-block;
              width: 42px;
              text-align: center;
            }

            .device_name {
              margin-left: 5px;
            }

            .delimiter {
              display: inline-block;
              width: 1px;
              height: 11px;
              background-color: #fff;
              opacity: 0.5;
              margin-right: 4px;
              margin-left: 8px;
            }
          }

          &.mobile-only {
            width: 156px;

            button {
              width: 156px;
            }
          }
        }

        .heatmap__control__play {
          display: inline-block;
          white-space: nowrap;
          margin-left: 20px;

          .checkbox_wrap {
            cursor: pointer;
            position: relative;

            .icon {
              position: absolute;
              top: 50%;
              left: 0;
              transform: translateY(-50%);
            }

            &:nth-last-of-type(1) {
              margin-left: 18px;
            }
          }

          .text {
            font-size: 14px;
            color: #2f2f2f;
            margin-left: 25px;
          }
        }

        > .heatmap__control_guide {
          display: flex;
          align-items: center;
          cursor: initial;

          &::before {
            content: '';
            display: inline-block;
            width: 1px;
            height: 12px;
            background: #d7d7d7;
            margin: 0 16px;
          }

          > span,
          a {
            color: #767676;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 12px; /* 100% */
          }

          > span {
            margin-right: 8px;
          }

          > a {
            cursor: pointer;
          }

          > .icon.icon--bc-step {
            width: 14px;
            height: 14px;
            padding: 0;
            background-position: 0px center;
          }
        }
      }
    }

    &.content__capture {
      display: flex;
      justify-content: space-between;
      position: relative;

      .box-layout {
        width: calc(50% - 15px); // height는 width의 80%
        box-sizing: border-box;
        max-height: 395px;

        .capture__info {
          display: flex;
          align-items: center;
          width: 100%;

          &.aType {
            align-items: normal;
          }

          .label {
            width: 75px;
            height: 75px;
            border-radius: 5px;
            position: relative;
            margin-right: 20px;
            flex-grow: 0;

            span {
              @include positionXYcenter;
              font-size: 30px;
              font-weight: 600;
              color: #ffffff;
            }
          }

          .info {
            align-items: center;
            max-width: calc(100% - 95px);
            flex-grow: 1;

            .infos {
              display: flex;
              width: 100%;

              .name {
                display: inline-block;
                font-size: 15px;
                font-weight: 600;
                color: #444444;
                align-items: center;
              }

              .traffic {
                font-size: 15px;
                font-weight: 600;
                color: #444444;
                position: relative;
                padding-left: 10px;
                margin-left: 10px;
                display: inline-block;
                vertical-align: top;
                align-items: center;
                flex-grow: 0;

                &:before {
                  @include positionYcenter;
                  left: 0;
                  content: '';
                  display: inline-block;
                  width: 1px;
                  height: 10px;
                  border-left: 1px solid #d8d8d8;
                }
              }
            }

            .url {
              position: relative;
              padding-left: 21px;
              margin-top: 14px;
              font-size: 13px;
              color: #444444;
              word-break: break-all;
              display: -webkit-flex;
              line-height: 16px;

              & > a {
                position: absolute;
                top: 0;
                left: 0;
              }
            }

            .items {
              @include textEllipsis;
              position: relative;
              margin-top: 14px;
              font-size: 13px;
              color: #444444;
            }
          }
        }

        .capture__img {
          // height는 width의 60%
          clear: both;
          border-radius: 4px;
          box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.05);
          background-color: #151515;
          margin-top: 20px;
          overflow-y: auto;
          box-sizing: border-box;
          border: 1px solid #e8e8e8;
          text-align: center;
          aspect-ratio: 52 / 25;
          max-height: 250px;
          width: 100%;

          img {
            display: inline-block;
            width: 100%;
          }
        }
      }

      .a-page {
        .label {
          background-color: #9fce12;
        }
      }

      .b-page {
        height: fit-content;

        .label {
          background-color: #1199af;
        }
      }
    }

    &.content__result {
      margin-top: 30px;
      position: relative;
      min-height: 340px;

      &.a-type {
        .box-layout {
          border-color: #57AB00;
        }

        .result-bot {
          background-image: url('../../assets/img/report-ab/icon-result-a.svg');
        }
      }

      &.b-type {
        .box-layout {
          border-color: #0B7D8D;
        }

        .result-bot {
          background-image: url('../../assets/img/report-ab/icon-result-b.svg');
        }
      }

      &.check-type {
        .result-bot {
          background-image: url('../../assets/img/report-ab/icon-result-chk.svg');
        }
      }

      .box-layout {
        border: 3px solid #8f8f8f;
        padding: 30px 30px 40px;
        box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08)
      }

      .sub-title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        h6 {
          font-size: 22px;
          color: #444;
          font-weight: 600;
          line-height: 26px;
        }

        .title-right {
          display: flex;
          align-items: center;
          gap: 12px;
          padding-right: 90px;

          span {
            color: #888;
            font-size: 13px;
            font-weight: 600;
          }

          .result-bot {
            position: absolute;
            right: 30px;
            top: 21px;
            display: block;
            width: 70px;
            height: 48px;
            background-repeat: no-repeat;
            background-size: contain;
          }

        }
      }

      .result-loading {
        padding: 70px 0 77px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        text-align: center;

        .loading-bot {
          width: 80px;
          height: 80px;
          display: block;
          align-self: center;
          background: url('../../assets/img/report-ab/icon-result-loading.svg?url') no-repeat center / contain;
        }

        .loading-msg {
          color: #2f2f2f;
          font-size: 13px;
        }
      }

      .result-data {
        border-top: 1px solid #e0e0e0;
        padding-top: 24px;
        margin-top: 24px;
        display: flex;
        flex-direction: column;
        gap: 36px;

        .result-answer {
          display: flex;
          flex-direction: column;
          gap: 12px;
          color: #0074ff;

          .tit {
            font-size: 20px;
            font-weight: 700;
            line-height: 150%;
          }

          .desc {
            font-size: 18px;
            font-weight: 600;
            line-height: 150%;
          }
        }
      }
    }

    &.content__traffic-ratio {
      margin-top: 30px;

      .box-layout {
        padding-bottom: 30px;
        color: #444444;
      }

      .sub-title {
        font-size: 15px;
        font-weight: 600;
      }

      .traffic-ratio__formula {
        font-size: 13px;
        float: right;
        font-weight: 500;
      }

      .traffic-ratio__bar {
        position: relative;
        margin-top: 30px;
        background-color: #f0f0f0;
        border-radius: 12.5px;
        height: 25px;
        overflow: hidden;

        .value__exclude {
          color: #555;
        }

        .value__exclude,
        .value__a-page,
        .value__b-page {
          @include positionXYcenter;
          font-size: 12px;
          font-weight: 600;
        }

        .a-page__area {
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-color: #9fce12;
          color: #ffffff;

          &.noBarWidth {
            .value__a-page {
              color: #666;
              left: 35px;
            }
          }
        }

        .b-page__area {
          height: 100%;
          position: absolute;
          top: 0;
          right: 0;
          background-color: #1199af;
          color: #ffffff;

          &.noBarWidth {
            .value__b-page {
              color: #666;
              left: -20px;
            }
          }
        }
      }
    }

    &.content__summary {
      margin-top: 70px;

      .title {
        font-size: 22px;
        font-weight: 600;
        color: #444444;
      }

      .box__graph {
        margin-top: 30px;
        padding: 30px 40px;
        text-align: center;

        .button--wrap {
          display: inline-block;
          position: relative;
          text-align: center;
          white-space: nowrap;
          height: 38px;
          border-radius: 20px;
          border: 1px solid #e0e0e0;
          background-color: #fff;
          box-sizing: border-box;

          li {
            cursor: pointer;
            display: inline-block;
            box-sizing: border-box;
            height: 38px;
            line-height: 36px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
            color: #888888;
            border-radius: 20px;
            padding-left: 15px;
            padding-right: 15px;

            &.on {
              position: relative;
              top: -1px;
              box-shadow: 0 12px 10px -4px rgba(0, 0, 0, 0.2);
              border: solid 1px #ec0147;
              background-color: #ec0147;
              color: #fff;
            }

            &:not(:nth-of-type(1)) {
              margin-left: -5px;
            }
          }
        }
      }

      .box__indicator {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;

        .box-layout {
          width: calc(50% - 15px);
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .label {
            position: relative;
            display: inline-block;
            width: 38px;
            height: 38px;
            border-radius: 5px;
            margin-right: 22px;

            &.style1 {
              background-color: #9fce12;
            }

            &.style2 {
              background-color: #1199af;
            }

            .emphasis {
              @include positionXYcenter;
              font-size: 20px;
              font-weight: 600;
              color: #ffffff;
            }
          }

          .indicator--wrap {
            width: 40%;
            box-sizing: border-box;

            li {
              white-space: nowrap;
              margin-top: 12px;

              &:nth-of-type(1) {
                margin-top: 0;
              }

              &.largeA {
                .aValue {
                  color: #9fce12;
                }
              }

              &.largeB {
                .bValue {
                  color: #1199af;
                }
              }

              .icon {
                vertical-align: text-top;
                margin-right: 5px;
              }

              .value {
                float: right;
              }
            }
          }

          .divide {
            display: inline-block;
            width: 1px;
            height: 100%;
            border-right: 1px solid #d8d8d8;
          }
        }
      }
    }

    &.content__conversion-rate {
      margin-top: 70px;

      .box-layout {
        margin-top: 30px;
      }

      .button--wrap {
        display: flex;
        align-items: center;
        justify-content: center;

        ul {
          display: inline-block;
          position: relative;
          text-align: center;
          white-space: nowrap;
          height: 38px;
          border-radius: 20px;
          border: 1px solid #e0e0e0;
          background-color: #fff;
          box-sizing: border-box;

          li {
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            column-gap: 8px;
            box-sizing: border-box;
            height: 38px;
            line-height: 36px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
            color: #888888;
            border-radius: 20px;
            padding-left: 15px;
            padding-right: 15px;

            &.on {
              position: relative;
              top: -1px;
              box-shadow: 0 12px 10px -4px rgba(0, 0, 0, 0.2);
              border: solid 1px #ec0147;
              background-color: #ec0147;
              color: #fff;
            }

            &:not(:nth-of-type(1)) {
              margin-left: -5px;
            }
          }
        }
      }

      .multi-box {
        display: flex;
        flex-direction: column;
        row-gap: 70px;
      }

      .title {
        font-size: 22px;
        font-weight: 600;
        color: #444444;
      }

      .sub-title {
        margin-bottom: 20px;

        font-size: 16px;
        font-weight: 500;
        color: #444444;
      }

      table {
        width: 100%;

        th {
          font-size: 14px;
          line-height: 1;
          text-align: center;
          color: #ffffff;

          height: 50px;

          &.th__a {
            background-color: #9fce12;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
          }

          &.th__improve {
            background-color: #555555;
          }

          &.th__ranking {
            background-color: #555555;
          }

          &.th__b {
            background-color: #1199af;
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
          }

          &.th--left {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
          }

          &.th--right {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
          }
        }

        td {
          height: 90px;
          text-align: center;
          border-bottom: 1px solid #979797;
        }

        .td__a-value {
          border-right: 1px dashed #d7d7d7;

          &.largeA {
            color: #9fce12;
          }
        }

        .td__b-value {
          border-left: 1px dashed #d7d7d7;

          &.largeB {
            color: #1199af;
          }
        }

        .td__a-text {
          border-right: 1px solid #ebebeb;
          border-bottom: 1px solid #ebebeb;

          .box {
            display: grid;
            grid-template-columns: auto 60px;
            column-gap: 60px;
            align-items: center;

            height: 100%;
            padding: 0px 20px;

            &__text {
              text-align: start;
            }
          }
        }

        .td__b-text {
          border-right: 1px solid #ebebeb;
          border-bottom: 1px solid #ebebeb;

          .box {
            display: grid;
            grid-template-columns: auto 60px;
            column-gap: 60px;
            align-items: center;

            height: 100%;
            padding: 0px 20px;

            &__text {
              text-align: start;
            }
          }
        }

        .td__rate-text {
          border-bottom: 1px solid #ebebeb;

          .box {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            column-gap: 5px;

            height: 100%;
            padding: 0px 20px;

            background-color: #f4f4f1;
          }
        }

        .td__separate {
          & > div {
            height: 50%;
            line-height: 45px;

            a {
              font-size: 12px;
              line-height: 1;
              color: #777777;
            }
          }

          .bar--wrap {
            border-top: 1px dashed #d7d7d7;
            position: relative;
            height: 100%;

            .a-bar,
            .b-bar {
              position: relative;
              width: calc(50% - 5px);
              height: 100%;
              display: inline-block;

              i {
                width: 50px;
                @include positionYcenter;
                display: inline-block;
                content: '';
                height: 10px;
                border-radius: 7px;
              }
            }

            .a-bar {
              i {
                right: 1px;
                background-color: #9fce12;
              }
            }

            .b-bar {
              i {
                left: 0;
                background-color: #1199af;
              }
            }

            .divide {
              @include positionXYcenter;
              display: inline-block;
              border-left: 1px solid #979797;
              width: 1px;
              height: 100%;
            }
          }
        }
      }
    }

    &.content__click-per-pv {
      margin-top: 70px;

      .box-layout {
        margin-top: 30px;
      }

      .title {
        font-size: 22px;
        font-weight: 600;
        color: #444444;
      }

      table {
        width: 100%;

        th {
          font-size: 14px;
          line-height: 1;
          text-align: center;
          color: #ffffff;

          height: 50px;

          &.th__a {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
            background-color: #9fce12;
          }

          &.th__b {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
            background-color: #1199af;
          }

          &.th__ranking {
            background-color: #555555;
          }
        }

        td {
          text-align: center;
          border-bottom: 1px solid #ebebeb;
          box-sizing: border-box;
        }

        .td__a-value {
          position: relative;
          border-right: 1px solid #ebebeb;

          figure {
            img {
              display: inline-block;
              width: 50px;
              height: 25px;
              background-color: red;
            }
          }
        }

        .td__b-value {
          position: relative;
          border-left: 1px solid #ebebeb;

          figure {
            img {
              display: inline-block;
              width: 50px;
              height: 25px;
              background-color: blue;
            }
          }
        }

        .td__ranking {
          .ranking--wrap {
            display: flex;
            justify-content: center;

            & > div {
              width: calc(100% / 3);
              line-height: 60px;
            }

            .rank {
              position: relative;
              background-color: #ebebeb;
              color: #444;
              font-size: 14px;
              font-weight: 600;

              &:after {
                position: absolute;
                top: 100%;
                left: 0;
                content: '';
                display: inline-block;
                border-bottom: 1px solid #c1c1c1;
                width: 100%;
                height: 1px;
                box-sizing: border-box;
              }
            }

            .a-page-value span,
            .b-page-value span {
              font-size: 13px;
              line-height: 1.23;
              color: #2f2f2f;
            }

            .a-page-value span.largeA {
              color: #9fce12;
            }

            .b-page-value span.largeB {
              color: #1199af;
            }
          }
        }
      }
    }

    &.content__conversion-target-rate {
      margin-top: 70px;

      .title__wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
          font-size: 22px;
          font-weight: 600;
          color: #444444;
        }

        .button__wrap {
          display: inline-block;
          position: relative;
          text-align: center;
          white-space: nowrap;
          height: 32px;
          border-radius: 20px;
          border: 1px solid #d7d7d7;
          box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.04);
          background-color: rgba(0, 0, 0, 0.06);
          box-sizing: border-box;

          li {
            cursor: pointer;
            display: inline-block;
            box-sizing: border-box;
            height: 32px;
            font-size: 13px;
            font-weight: 600;
            text-align: center;
            color: #666;
            padding-left: 10px;
            padding-right: 10px;

            &.on {
              position: relative;
              height: 30px;
              border-radius: 20px;
              background-color: #fff;
              color: #444;
              box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
            }

            span {
              line-height: 13px;
              margin-top: 8.5px;
              margin-left: 5px;
              display: inline-block;
            }

            .icon {
              top: 3px;
              position: relative;
            }

            // &:not(:nth-of-type(1)) {
            //   margin-left: -5px;
            // }
          }
        }
      }

      .flow {
        padding: 30px 50px;
      }

      .box-layout {
        margin-top: 25px;
        color: #444444;

        .box-layout-inner__wrap {
          display: flex;
          justify-content: center;

          .page-division__wrap {
            display: flex;
            flex-direction: column;
            row-gap: 65px;

            .label__wrap {
              p {
                margin-bottom: 8px;
                font-size: 13px;
                font-weight: 500;
                line-height: 1;
                position: absolute;
                margin-top: -20px;
              }

              .a {
                color: #9fce12;
              }

              .b {
                color: #1199af;
              }

              .a-label {
                position: relative;
                width: 38px;
                height: 38px;
                border-radius: 7px;
                background-color: #9fce12;

                i {
                  @include positionXYcenter;
                  font-size: 20px;
                  font-weight: 500;
                  font-weight: 600;
                  color: #ffffff;
                }
              }

              .b-label {
                position: relative;
                width: 38px;
                height: 38px;
                border-radius: 7px;
                background-color: #1199af;

                i {
                  @include positionXYcenter;
                  font-size: 20px;
                  font-weight: 500;
                  font-weight: 600;
                  color: #ffffff;
                }
              }

              .drop-off {
                display: flex;
                align-items: center;
                position: absolute;
                margin-left: 50px;
                font-size: 14px;
                font-weight: 500;
                line-height: 1;
                color: #ff4a00;

                .icon--arrow-dropoff-large {
                  width: 20px;
                  height: 20px;
                  margin-right: 5px;
                  background-image: url(../../assets/img/arrow/img-common-arrow-dropoff-s-2-1.svg);
                }

                .icon--arrow-dropoff-medium {
                  width: 20px;
                  height: 20px;
                  margin-right: 5px;
                  background-image: url(../../assets/img/arrow/img-common-arrow-dropoff-s-2-2.svg);
                }

                .icon--arrow-dropoff-small {
                  width: 20px;
                  height: 20px;
                  margin-right: 5px;
                  background-image: url(../../assets/img/arrow/img-common-arrow-dropoff-s-2-3.svg);
                }
              }
            }
          }

          .node__wrap {
            margin-left: 15px;
            min-width: 270px;

            .trend-paths {
              height: 100%;
              // position: absolute;
            }
          }

          .target__wrap {
            display: flex;
            flex-direction: column;

            .target {
              display: flex;
              align-items: center;
              border-bottom: 0.5px solid #bbb;
              padding: 30px 0px;

              .ratio__wrap {
                display: flex;
                flex-direction: column;
                justify-content: center;
                row-gap: 35px;
                position: absolute;
                margin-left: -45px;

                .ratio {
                  font-weight: 500;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 1;
                  letter-spacing: normal;
                  text-align: right;
                  padding-right: 5px;
                  font-size: 13px;
                }

                .a {
                  color: #9fce12;
                }

                .b {
                  color: #1199af;
                }

                &.ratio-etc {
                  // row-gap: 30px
                  display: none;
                }
              }

              .thumbnail {
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #f4f4f4;
                width: 140px;
                height: 140px;
                box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12),
                0 4px 7px -2px rgba(0, 0, 0, 0.3);
                border-radius: 5px;

                img {
                  display: inline-block;
                  width: 140px;
                  height: 140px;
                  object-fit: cover;
                  object-position: 0 0;
                  border-radius: 5px;
                }

                .icon-empty-image {
                  width: 32px;
                  height: 32px;
                  background-image: url(../../assets/img/icon-empty-image.svg);

                  &.deleted {
                    background-image: url(../../assets/img/icon-deleted-image.svg);
                  }
                }
              }

              .info {
                width: 550px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-left: 30px;
                flex: 1;

                .info-title__wrap {
                  display: flex;
                  margin-top: 17px;

                  .icon {
                    margin-top: 2px;
                    min-width: 16px;
                    cursor: pointer;
                  }

                  .icon--common-page-link {
                    &.disabled {
                      cursor: initial;
                      filter: none;
                      opacity: 0.3;
                    }
                  }

                  .title {
                    font-size: 14px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.5;
                    letter-spacing: normal;
                    color: #444;
                    @include textEllipsis;
                  }

                  .clipboard {
                    margin-right: 10px;
                  }

                  .ab {
                    margin-right: 8px;
                    // padding-right: 16px;
                  }
                }

                .url__wrap {
                  position: relative;
                  display: flex;
                  margin-top: 13px;

                  .clipboard {
                    margin: 12px 10px 0px 0px;
                  }

                  .textarea {
                    border-radius: 5px;
                    background-color: #f4f4f4;
                    padding: 10px;
                    font-size: 13px;
                    line-height: 1.54;
                    letter-spacing: normal;
                    color: #444;
                    width: 100%;

                    span {
                      word-break: break-all;
                      overflow-y: overlay;
                      display: -webkit-box;
                      -webkit-box-orient: vertical;
                      -webkit-line-clamp: 5;
                    }

                    span::-webkit-scrollbar {
                      background-color: transparent;
                    }
                  }

                  &:hover {
                    .textarea {
                      box-shadow: 0 0 0 1px #d7d7d7 inset;
                    }
                  }

                  .content__toast {
                    display: inline-block;
                    height: 32px;
                    border-radius: 6px;
                    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16);
                    background-color: rgba(0, 0, 0, 0.85);
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    padding-left: 12px;
                    padding-right: 45px;
                    opacity: 1;
                    filter: initial;
                    z-index: 9999999;

                    span {
                      font-size: 13px;
                      font-weight: 600;
                      color: #57ab00;
                      line-height: 32px;
                    }

                    i {
                      position: absolute;
                      top: 50%;
                      right: 12px;
                      transform: translateY(-50%);
                    }
                  }
                }

                .status__wrap {
                  display: flex;
                  align-items: center;

                  .status {
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 1;
                    margin-left: 5px;
                  }

                  .end {
                    color: #b240ff;
                  }

                  .delete {
                    color: #e92020;
                  }

                  .scheduled {
                    color: #ff8402;
                  }

                  .analyzing {
                    color: #1199af;
                  }

                  .stop,
                  .tempstop {
                    color: #767676;
                  }

                  .icon--deleted {
                    opacity: 1;
                    position: relative;
                    width: 20px;
                    height: 20px;
                    margin-left: 15px;
                    background-image: url(../../assets/img/arrow/ic-common-warning-2-20-dp.svg);
                  }

                  .matchtype {
                    font-size: 12px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1;
                    letter-spacing: normal;
                    color: #fff;
                    border-radius: 4px;
                    background-color: #8d8d8d;
                    padding: 2px 5px;
                  }

                  .bubble {
                    bottom: calc(50% - 16px);
                    left: calc(50% - 2px);
                    transform: translate(-50%, -50%);
                    opacity: 1;
                  }
                }
              }

              .etc {
                width: 140px;
                height: 70px;
                border: 1px #bbb;
                text-align: center;
                border-radius: 35px;
                box-shadow: 0 5px 7px -3px rgba(0, 0, 0, 0.2),
                0 0 0 1px rgba(0, 0, 0, 0.12);
                background-color: #fff;
                font-size: 14px;
                line-height: 1.5;
                letter-spacing: normal;
                text-align: center;
                color: #8d8d8d;
                line-height: 70px;
                margin: 0px;
              }
            }

            .etc {
              border: none;
            }
          }
        }

        .box-layout-table__wrap {
          margin-top: 50px;

          .info {
            min-width: 550px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-bottom: 20px;

            .info-title__wrap {
              display: flex;
              margin-top: 17px;

              .icon {
                margin-top: 2px;
                cursor: pointer;
                min-width: 16px;
              }

              .icon--common-page-link {
                &.disabled {
                  cursor: initial;
                  filter: none;
                  opacity: 0.3;
                }
              }

              .title {
                font-size: 14px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.5;
                letter-spacing: normal;
                color: #444;
              }

              .clipboard {
                margin-right: 10px;
              }

              .ab {
                margin-right: 8px;
              }
            }

            .url__wrap {
              position: relative;
              display: flex;
              margin-top: 13px;

              .clipboard {
                margin: 12px 10px 0px 0px;
              }

              .textarea {
                border-radius: 5px;
                background-color: #f4f4f4;
                padding: 10px;
                font-size: 13px;
                line-height: 1.54;
                letter-spacing: normal;
                color: #444;
                width: 100%;

                span {
                  word-break: break-all;
                  overflow-y: overlay;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 5;
                }

                span::-webkit-scrollbar {
                  background-color: transparent;
                }
              }

              &:hover {
                .textarea {
                  box-shadow: 0 0 0 1px #d7d7d7 inset;
                }
              }

              .content__toast {
                display: inline-block;
                height: 32px;
                border-radius: 6px;
                box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16);
                background-color: rgba(0, 0, 0, 0.85);
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                padding-left: 12px;
                padding-right: 45px;

                span {
                  font-size: 13px;
                  font-weight: 600;
                  color: #57ab00;
                  line-height: 32px;
                }

                i {
                  position: absolute;
                  top: 50%;
                  right: 12px;
                  transform: translateY(-50%);
                }
              }
            }

            .status__wrap {
              display: flex;
              align-items: center;

              .status {
                font-size: 14px;
                font-weight: 500;
                line-height: 1;
                margin-left: 5px;
              }

              .end {
                color: #b240ff;
              }

              .delete {
                color: #e92020;
              }

              .scheduled {
                color: #ff8402;
              }

              .analyzing {
                color: #1199af;
              }

              .stop,
              .tempstop {
                color: #767676;
              }

              .tempstop {
                color: #767676;
              }

              .icon--deleted {
                position: relative;
                width: 20px;
                height: 20px;
                margin-left: 15px;
                background-image: url(../../assets/img/arrow/ic-common-warning-2-20-dp.svg);
              }

              .report-tooltip {
                opacity: 0;
              }

              &:hover {
                .report-tooltip {
                  opacity: 1;
                  transform: translate(-50%, 0);
                }
              }

              .matchtype {
                font-size: 12px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                color: #fff;
                border-radius: 4px;
                background-color: #8d8d8d;
                padding: 2px 5px;
              }

              .bubble {
                top: calc(50% - 45px);
                left: -8px;
                transform: translate(0, -50%);
                opacity: 1;
              }
            }
          }
        }

        .first {
          margin-top: 0px;
        }
      }

      table {
        width: 100%;

        th {
          font-size: 14px;
          line-height: 1;
          text-align: center;
          color: #ffffff;

          height: 50px;

          &.th__a {
            background-color: #9fce12;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
          }

          &.th__improve {
            background-color: #555555;
          }

          &.th__ranking {
            background-color: #555555;
          }

          &.th__b {
            background-color: #1199af;
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
          }

          &.th--left {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
          }

          &.th--right {
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
          }
        }

        td {
          height: 90px;
          text-align: center;
          border-bottom: 1px solid #979797;
        }

        .td__a-value {
          border-right: 1px dashed #d7d7d7;

          &.largeA {
            color: #9fce12;
          }
        }

        .td__b-value {
          border-left: 1px dashed #d7d7d7;

          &.largeB {
            color: #1199af;
          }
        }

        .td__a-text {
          border-right: 1px solid #ebebeb;
          border-bottom: 1px solid #ebebeb;

          .box {
            display: grid;
            grid-template-columns: auto 60px;
            column-gap: 60px;
            align-items: center;

            height: 100%;
            padding: 0px 20px;

            &__text {
              text-align: start;
            }
          }
        }

        .td__b-text {
          border-right: 1px solid #ebebeb;
          border-bottom: 1px solid #ebebeb;

          .box {
            display: grid;
            grid-template-columns: auto 60px;
            column-gap: 60px;
            align-items: center;

            height: 100%;
            padding: 0px 20px;

            &__text {
              text-align: start;
            }
          }
        }

        .td__rate-text {
          border-bottom: 1px solid #ebebeb;

          .box {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            column-gap: 5px;

            height: 100%;
            padding: 0px 20px;

            background-color: #f4f4f1;
          }
        }

        .td__separate {
          & > div {
            height: 100%;
            line-height: 45px;
            position: relative;

            a {
              font-size: 12px;
              line-height: 1;
              color: #777777;
            }
          }

          .a-bar,
          .b-bar {
            position: relative;
            width: calc(50% - 5px);
            height: 100%;
            display: inline-block;

            i {
              width: 50px;
              @include positionYcenter;
              display: inline-block;
              content: '';
              height: 10px;
              border-radius: 7px;
            }
          }

          .a-bar {
            i {
              right: 1px;
              background-color: #9fce12;
            }
          }

          .b-bar {
            i {
              left: 0;
              background-color: #1199af;
            }
          }

          .divide {
            @include positionXYcenter;
            display: inline-block;
            border-left: 1px solid #979797;
            width: 1px;
            height: 100%;
          }
        }
      }

      .deletedTable {
        filter: none;
        opacity: 0.4;
      }

      .deleted {
        & .matchtype,
        & .title,
        & .url__wrap a,
        & .url__wrap .textarea {
          filter: none;
          opacity: 0.4;
        }
      }
    }
  }
}
</style>
